import { useSetAtom } from 'jotai';
import { RESET } from 'jotai/utils';
import { useEffect } from 'react';

import {
  atomActionsList,
  atomLoadingProcess,
  atomTotalsProcess,
} from '@/modules/CampaignsModule/atoms/campaignAtom';

export const useResetAtomOnUnmount = () => {
  const setTotalsProcess = useSetAtom(atomTotalsProcess);
  const setLoadingProcess = useSetAtom(atomLoadingProcess);
  const setActionsList = useSetAtom(atomActionsList);

  useEffect(() => {
    return () => {
      setActionsList(RESET);
    };
  }, [setActionsList]);

  useEffect(() => {
    return () => {
      setTotalsProcess(RESET);
      setLoadingProcess(RESET);
    };
  }, [setTotalsProcess, setLoadingProcess]);

  const resetAtomActionsList = () => {
    setActionsList(RESET);
  };

  const resetAtomProcess = () => {
    setTotalsProcess(RESET);
    setLoadingProcess(RESET);
  };

  return { resetAtomProcess, resetAtomActionsList };
};
